// extracted by mini-css-extract-plugin
export var logo = "_bu-2";
export var logoWrapper = "_bu-1";
export var strip = "_bu-0";